// extracted by mini-css-extract-plugin
export default {"primary":"#0222ba","white":"#ffffff","breakpoint":"1120px","gutter":"16px"};